// js/common/product/variant-picker-bundle.js
var VariantPickerBundle = class extends HTMLElement {
  async connectedCallback() {
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option]"));

    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("click", this._onOptionChanged.bind(this));
    });
  }

  _onOptionChanged(event) {
    this.optionSelectors.forEach(option => {
      option.classList.remove('is-active');
    })
    if(!event.target.classList.contains('is-active'))
      event.target.classList.add('is-active');
    // handle size change display
    if(typeof DisplayCurrentSize !== "undefined") DisplayCurrentSize();
  }

};

if (!window.customElements.get("variant-picker-bundle")) {
  window.customElements.define("variant-picker-bundle", VariantPickerBundle);
}

// modal popup
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.disableScroll();
    this.setAttribute('open', '');
  }

  hide() {
    if(this.id != 'personalize-options') document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.enableScroll();
  }

 disableScroll() {
    // Get the current page scroll position
    let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;
   let scrollLeft =
        window.pageXOffset ||
        document.documentElement.scrollLeft;

        // if any scroll is attempted,
        // set this to the previous value
        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };
   }
  enableScroll() {
    window.onscroll = function () { };
  }

}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.popup-btn');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
      if(button.classList.contains('option-content_btn')
      && typeof fillOptionsPopup !== "undefined") fillOptionsPopup(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

// add bundles to cart
(function(){
  window.addEventListener('DOMContentLoaded', () => {
    let bundleAddToCartBtn = document.querySelector('[data-bundle-components]'),
        pickProductCheckbox = document.querySelector('.pick__product--wrapper .check__mark'),
        firstProductWrapper = document.querySelector('.first-product'),
        priceContainer = document.querySelector('.product-info__price sale-price');
    // handle bundle components add to cart
    if(bundleAddToCartBtn){
      bundleAddToCartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let formItems = [];
        let selectedVariants = document.querySelectorAll('.product-info__wrapper variant-picker-bundle:not(.disabled) .block-swatch.is-active');
        let  setID = Date.now().toString().slice(5);
        // disable add to cart btn
        bundleAddToCartBtn.setAttribute("disabled", "disabled");
        bundleAddToCartBtn.setAttribute("aria-busy", "true");
        // prepare request
        let sectionsToBundle = ["variant-added"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
        selectedVariants.forEach(option => {
          let item = {
            'id': parseInt(option.dataset.variantId),
            'quantity': 1,
            'properties': {
              '_suit': true,
              '_mainProductHandle': bundleAddToCartBtn.dataset.bundleHandle,
              '_setId': setID
            }
          };
          formItems.unshift(item);
        });
        // finalize form data
        let formData = {
          'items': formItems,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname
        };
        fetch(`${Shopify.routes.root}cart/add.js`, {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(async function (response) {
          const responseJson = await response.json();
          bundleAddToCartBtn.removeAttribute("disabled");
          bundleAddToCartBtn.removeAttribute("aria-busy");
          if (response.ok) {
            if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
              return window.location.href = `${Shopify.routes.root}cart`;
            }
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];

            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent
              }
            }));
          } else {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }
        })
      })
    }
    // handle pick product checkbox
    if(pickProductCheckbox && firstProductWrapper){
      pickProductCheckbox.addEventListener('click', () => {
        const totalPrice = pickProductCheckbox.dataset.mainPrice;
        const priceWithNoJacket = pickProductCheckbox.dataset.noJacketPrice;
        const pantsTab = document.querySelector('.tabs__wrapper [data-tab="pants"]');
        const jacketTab = document.querySelector('.tabs__wrapper [data-tab="jacket"]');
        const jacketDropdown = document.querySelector('.dropdown.jacket-summary');
        const tabsWrapper = document.querySelector('.tabs__wrapper');
        const extraPantsActive = document.querySelector('.extra-pants__content .is-active');
        const sizeJacket = document.querySelector('.size__wrapper .jacket-size');
        const sizePants = document.querySelector('.size__wrapper .pants-size');

        if(!pickProductCheckbox.classList.contains('is-active')){
          pickProductCheckbox.classList.add('is-active');
          firstProductWrapper.classList.add('disabled');
          if(popupContent) popupContent['jacket_exist'] = false;
          if(priceContainer) priceContainer.innerHTML = priceWithNoJacket;
          if(tabsWrapper) tabsWrapper.setAttribute('data-product-price', parseInt(tabsWrapper.dataset.baseProductPrice) - parseInt(tabsWrapper.dataset.productJacketPrice));
          if(jacketTab && jacketDropdown){
            jacketTab.classList.add('disable');
            jacketTab.classList.remove('is-active');
            jacketDropdown.setAttribute('hidden', '');
          }
          if(pantsTab) pantsTab.click();
          if(sizeJacket) sizeJacket.setAttribute('hidden', '');
          if(sizePants) sizePants.classList.add('option-content_btn-0');
        }else{
          pickProductCheckbox.classList.remove('is-active');
          firstProductWrapper.classList.remove('disabled');
          if(popupContent) popupContent['jacket_exist'] = true;
          if(tabsWrapper) tabsWrapper.setAttribute('data-product-price', tabsWrapper.dataset.baseProductPrice);
          if(jacketTab && jacketDropdown){
            jacketTab.classList.remove('disable');
            jacketTab.classList.add('is-active');
            jacketTab.click();
            jacketDropdown.removeAttribute('hidden');
          }
          if(priceContainer) priceContainer.innerHTML = totalPrice;
          if(sizeJacket) sizeJacket.removeAttribute('hidden');
          if(sizePants) sizePants.classList.remove('option-content_btn-0');
        }
        if(extraPantsActive) extraPantsActive.classList.remove('is-active');
      })
    }
    // handle bundle cart items quantity change
    document.addEventListener('bundle:quantity-change', async (event) => {
      if(event.detail.setId && event.detail.id){
        let bundleItems = document.querySelectorAll(`.line-item[data-set-id="${event.detail.setId}"]`);
        let bundleList = {};
        let storedList = localStorage.getItem('customizationList');
        let listOfObjects;

        if(storedList){
          listOfObjects = JSON.parse(storedList);
        }
        bundleItems.forEach(item => {
         let objectData = objectExists(item.dataset.bundleMainProduct, event.detail.setId, listOfObjects);
         let quantityValue = event.detail.quantity;

         if(item.dataset.type
          && item.dataset.type == 'pants'
          && typeof objectData != 'undefined'
          && typeof objectData['data']['extra_pants'] != 'undefined'
          && objectData['data']['extra_pants'] && quantityValue != 0){
          quantityValue = quantityValue + 1;
         }
          bundleList[item.dataset.cartItemId] = quantityValue;
        });
        if(Object.keys(bundleList).length){
          await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates: bundleList })
          });
          window.location.reload();
        }
      }
    });
  });
})();